import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import stone from '@/__vue2stone'
import i18n from './i18n';
import 'jodit/build/jodit.min.css'

Vue.config.productionTip = false

Vue.use(stone)

const files = require.context('./components/', true, /\.vue$/i);
files.keys().map((key) =>
  Vue.component(
    key
      .split('/')
      .pop()
      .split('.')[0],
    files(key).default,
  ),
);
const wsfiles = require.context('./__vue2stone/components/', true, /\.vue$/i);
wsfiles.keys().map((key) =>
  Vue.component(
    key
      .split('/')
      .pop()
      .split('.')[0],
    wsfiles(key).default,
  ),
);
const commonComponentsFiles = require.context('./__common/components/', true, /\.vue$/i);
commonComponentsFiles.keys().map((key) =>
  Vue.component(
    key
      .split('/')
      .pop()
      .split('.')[0],
    commonComponentsFiles(key).default,
  ),
);
const commonBaseComponentsFiles = require.context('./__common/baseComponents/', true, /\.vue$/i);
commonBaseComponentsFiles.keys().map((key) =>
  Vue.component(
    key
      .split('/')
      .pop()
      .split('.')[0],
      commonBaseComponentsFiles(key).default,
  ),
);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
